<template>
  <data-list
    ref="dataList"
    class="content md"
    :url="url"
    query="&sort=-id&expand=tabletRegion,tabletBlockItem"
    entity-name="区块"
    add-btn="新增区块"
    add-route="TabletBlockAdd"
    hide-show-detail
    :columns="columns"
    :action="action"
    :request-config="{ noTempleFilter: true }"
    @edit="editRow"
  >
    <template v-slot:query="{ form }">
      <a-form-model-item label="所属区域">
        <a-select
          style="width: 180px"
          placeholder="选择区域查询"
          allow-clear
          @change="updateList"
          :options="regionList"
          v-model="form.mem_tablet_region_id"
        >
        </a-select>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
export default {
  name: "TabletBlock",
  data() {
    return {
      url: "/admin/memorial-tablet-block",
      columns: [
        { title: "区块名称", dataIndex: "name" },
        {
          title: "所属区域",
          dataIndex: "tabletRegion",
          customRender: (text) => {
            return <span>{text?.name}</span>;
          },
        },
        {
          title: "龛位数量",
          dataIndex: "tabletBlockItem",
          customRender: (text) => {
            return <span>{text?.length || 0}</span>;
          },
        },
        {
          title: "是否开放",
          customRender: (record) => {
            return (
              <a-switch
                checked={record.is_open == 1}
                onChange={($event) => this.onChange($event, record)}
              ></a-switch>
            );
          },
        },
      ],
      regionList: [],
    };
  },
  computed: {
    action() {
      return this.$route.meta.action;
    },
    dataList() {
      return this.$refs.dataList;
    },
    update() {
      return this.$store.getters.update;
    },
  },
  watch: {
    update(val) {
      if(val && val.type == "tabletBlock") {
        this.updateList();
        this.$store.commit("changeUpdate", null);
      }
    },
  },
  created() {
    this.getRegion();
  },
  methods: {
    getRegion() {
      this.$axios({
        url: "/admin/memorial-tablet-region",
        method: "GET",
        params: {
          pageSize: 9999,
        },
        noTempleFilter: true,
      }).then((res) => {
        this.regionList = res.data?.map((item) => {
          item.key = item.id;
          item.title = item.name;
          return item;
        });
      });
    },
    onChange(checked, record) {
      let text = checked ? "开放" : "关闭";
      this.$confirm({
        title: "提示",
        content: `确定${text}此区块吗？`,
        onOk: () => {
          this.$axios({
            url: `${this.url}/${record.id}`,
            method: "PATCH",
            data: {
              is_open: checked ? 1 : 2,
            },
          }).then((res) => {
            record.is_open = res.is_open;
            this.$message.success(text + "成功");
          });
        },
      });
    },
    editRow(item) {
      this.$router.push({
        name: "TabletBlockEdit",
        params: { id: item.id },
      });
    },
    updateList() {
      this.dataList.updateList();
    },
  },
};
</script>

<style lang="less" scoped>
.tip-msg {
  color: grey;
}
</style>
